import React, { useEffect, useState } from "react";
import Profileandevents from "../../Landing/Profileandevents";

import toast from "react-hot-toast";
import BookViewPopUp from "./BookViewPopUp";
import Mobilecommonhead from "../../Mobilecommonhead";
import {
  getAcceptedBookings,
  getCompletedMeet,
  getPendingMeet,
} from "../../../api/menteeRequest";
import convertToNormalTime from "../../../utils/timeConversion";

// const MEET_STATUS = {
//   PENDING: "pending",
//   ACCEPTED: "accepted",
//   REJECTED: "rejected",
//   CANCELLED: "cancelled",
// };

function RequestedMeets({
  setProgress,
}) {


  // const displaynavmob = () => {
  //   var x = document.querySelector(".side-nav-mob");
  //   if (x.classList[1]) {
  //     x.classList.remove("display");
  //   } else {
  //     x.classList.add("display");
  //   }
  // };
  // const [book, setBook] = useState([]);
  const [accepted, setAccepted] = useState([]);
  const [pending, setPending] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [displaying, setDisplaying] = useState("upcomming");
  const [ShowBookPopUp, setShowBookPopUp] = useState(false);
  const [bookingData, setBookingData] = useState([]);
  const [initialRequest, setInitialRequest] = useState(false);

  const book =
  displaying === "accepted"
    ? accepted
    : displaying === "pending"
    ? pending
    : completed;


  const onClose = () => {
    setShowBookPopUp(false);
  };

  const showstatus = (e) => {
    document.querySelector(".accepted").classList.remove("up");
    document.querySelector(".completed").classList.remove("up");
    document.querySelector(".pending").classList.remove("up");
    e.target.classList.add("up");
    if (e.target.classList.contains("accepted")) {
      // setBook(upcomming);
      setDisplaying("accepted");
    } else if (e.target.classList.contains("pending")) {
      // setBook(pending);
      setDisplaying("pending");
    } else if (e.target.classList.contains("completed")) {
      // setBook(completed);
      setDisplaying("completed");
    }
  };

  useEffect(() => {
  const fetchAll = async () => {
    try {
      const [acc, pend, comp] = await Promise.all([
        getAcceptedBookings(),
        getPendingMeet(),
        getCompletedMeet(),
      ]);

      if (acc.data.result) setAccepted(acc.data.result);
      if (pend.data.result) setPending(pend.data.result);
      if (comp.data.result) setCompleted(comp.data.result);

      setInitialRequest(true);
    } catch (error) {
      if (error.response) toast.error(error.response.data.message);
    }
  };

  fetchAll();
}, []);


  return (
    <>
     
      <Profileandevents />
      <Mobilecommonhead />
      <div className="ml-[13vw] md:ml-0">
        {/* <Commondash userData={userData} /> */}

        <div className="dash-right">
          {/* <Profileandevents /> */}

          {/* <Topbar setProgress={setProgress}/> */}
          <div className="session-dash-info">
            <h2 className="meets-head text-2xl">Meets</h2>
            <div className="heading-session-status">
              <div
                className="accepted up"
                onClick={showstatus}
                style={{ cursor: "pointer" }}
              >
                Accepted
              </div>
              <div
                className="pending"
                onClick={showstatus}
                style={{ cursor: "pointer" }}
              >
                Pending
              </div>
              <div
                className="completed"
                onClick={showstatus}
                style={{ cursor: "pointer" }}
              >
                Completed
              </div>
            </div>

            {/* <div className="partition-session"></div> */}

            {ShowBookPopUp && (
              <BookViewPopUp
                type="Mentor"
                bookingData={bookingData}
                onClose={onClose}
              />
            )}

            {Object.entries(book).length === 0 ? (
              <div
                className="no-session"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  padding: "20px",
                  borderTop: "1px solid #00000033",
                }}
              >
                {initialRequest && <h3>No Sessions</h3>}
              </div>
            ) : (
              <div className="session-list-dash">
                {Object.entries(book).map(([date, items]) => (
                  <div className="session-list-dash-li hover:bg-gray-400/30">
                    <ul>
                      <li>Date: {new Date(date).toString().slice(0, 15)}</li>
                    </ul>
                    {Object.entries(items).map((item) => (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setBookingData(item);
                          setShowBookPopUp(true);
                        }}
                        className="individual-session"
                      >
                        <div>
                          {/* <img src={logo} /> */}

                          <span>
                            Timing:&nbsp;{convertToNormalTime(item[1].s)} -{" "}
                            {convertToNormalTime(item[1].e)}{" "}
                          </span>
                        </div>
                        <span>Number of Bookings :1</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default RequestedMeets;
